module.exports = __webpack_public_path__ + "img/en.ab498293.png";